module.exports = __webpack_public_path__ + "img/dp-sy-lm1.46497ee1.png";